import { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import DashboardManagementService from "../../API/DashboardManagement/DashboardManagementService";

const AddProduct = (props) => {
  const { t } = useTranslation();

  const {
    showmodal,
    handleModalClose,
    handleAddNoteModalCloseAfterAPICall,
    riskTypeList,
  } = props;

  const riskTypeOptions = Object.entries(riskTypeList).map(([key, label]) => ({
    value: key,
    label: label,
  }));

  const [formData, setFormData] = useState({
    name: "",
    assureur_ids: [],
    risk_type: "",
    description: "",
    qr_basis_ids: [],
    quotation_basis_ids: [],
    guarantee_basis_ids: [],
  });

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const [qRBasisList, setQRBasisList] = useState([]);
  const [quotationBasisList, setQuotationBasisList] = useState([]);
  const [guaranteeBasisList, setGuaranteeBasisList] = useState([]);
  const [insurerOptions, setInsurerOptions] = useState([]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    if (showmodal) {
      QRBasisList();
      GetInsurersList();
      QuotationBasisList();
      GuaranteeBasisList();
      setFormData({
        name: "",
        assureur_ids: [],
        risk_type: "",
        description: "",
        qr_basis_ids: [],
        quotation_basis_ids: [],
        guarantee_basis_ids: [],
      });
    }
  }, [showmodal]);

  const handleChange = (e) => {
    const { name, value, type, max } = e.target;
    let val = value;

    if (type === "number") {
      const numericValue = Number(value);
      const maxValue = max ? Number(max) : Infinity;
      val = Math.max(0, Math.min(maxValue, numericValue));
    }

    setFormData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const GetInsurersList = async () => {
    setLoading(true);
    try {

      const response = await DashboardManagementService.insurer_list();

      if (response.data) {
        setLoading(false);
        const insurerList = response.data.insurerList || [];
        const insurerOptions = insurerList.map((data) => ({ value: data.id, label: data.first_name }));
        setInsurerOptions(insurerOptions);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const QRBasisList = async () => {
    setLoading(true);
    try {
      const response = await FilePageService.admin_qr_basis_list();

      if (response.data.status) {
        setQRBasisList(response.data.basisList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const QuotationBasisList = async () => {
    setLoading(true);
    try {
      const response = await FilePageService.quotation_basis_list();

      if (response.data.status) {
        setQuotationBasisList(response.data.quotationBasisList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const GuaranteeBasisList = async () => {
    setLoading(true);
    try {
      const response = await FilePageService.guarantee_basis_list();

      if (response.data.status) {
        setGuaranteeBasisList(response.data.guaranteeBasisList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const AddProduct = async (e) => {
    e.preventDefault();
    if (loading) return;

    const {
      name,
      assureur_ids,
      risk_type,
      description,
      qr_basis_ids,
      quotation_basis_ids,
      guarantee_basis_ids,
    } = formData;

    if (
      !name ||
      !risk_type ||
      guarantee_basis_ids.length === 0
    ) {
      setFlashMessage({
        type: "error",
        message: t("requriedErrorMessageLabel"),
      });
      return;
    }

    setLoading(true);

    const payload = {
      name: name,
      ...(assureur_ids?.length > 0 && { assureur_ids: assureur_ids.map((q) => q.value) }),
      risk_type: risk_type,
      ...(description && { description: description }),
      ...(qr_basis_ids?.length > 0 && { qr_basis_ids: qr_basis_ids.map((q) => q.value) }),
      ...(quotation_basis_ids?.length > 0 && { quotation_basis_ids: quotation_basis_ids.map((q) => q.value) }),
      guarantee_basis_ids: guarantee_basis_ids.map((q) => q.value),
    };

    try {
      const response = await FilePageService.product_create(payload);

      if (response.data.status) {
        setLoading(false);
        setFormData({
          name: "",
          assureur_ids: [],
          risk_type: "",
          description: "",
          qr_basis_ids: [],
          quotation_basis_ids: [],
          guarantee_basis_ids: [],
        });
        handleAddNoteModalCloseAfterAPICall();
      } else {
        setLoading(false);
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setLoading(false);
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleQRBasisChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      qr_basis_ids: selected,
    }));
  };

  const handleQuotationBasisChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      quotation_basis_ids: selected,
    }));
  };

  const handleGuaranteeBasisChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      guarantee_basis_ids: selected,
    }));
  };

  const handleAssureurAssignChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      assureur_ids: selected,
    }));
  };

  const QRBasisOptions =
    qRBasisList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const QuotationBasisOptions =
    quotationBasisList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const GuaranteeBasisOptions =
    guaranteeBasisList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  return (
    <Fragment>
      <Modal
        className="missing-doc-modal invalid-doc-modal"
        show={showmodal}
        onHide={handleModalClose}
      >
        <Form onSubmit={AddProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter un produit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h2>Ajouter un produit</h2>

            {flashMessage.message && (
              <div
                className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                    ? "alert-success"
                    : "alert-danger"
                  } text-center`}
                role="alert"
              >
                {flashMessage.message}
              </div>
            )}

            <div className="mt-3">
              <Form.Group className="mb-3">
                <Form.Label>
                  Nom du produit <span>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nom du produit"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Assureur assigné</Form.Label>
                <MultiSelect
                  options={insurerOptions}
                  value={formData.assureur_ids}
                  onChange={handleAssureurAssignChange}
                  labelledBy="Sélectionnez Assureur"
                  overrideStrings={{
                    selectSomeItems: "Sélectionnez Assureur",
                    allItemsAreSelected:
                      "Toutes les options sont sélectionnées",
                    selectAll: "Tout sélectionner",
                    search: "Recherche",
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Type de risque <span>*</span>
                </Form.Label>
                <Select
                  options={riskTypeOptions}
                  value={riskTypeOptions.find(
                    (option) => option.value === formData.risk_type
                  )}
                  onChange={(selectedOption) =>
                    setFormData((prev) => ({
                      ...prev,
                      risk_type: selectedOption.value,
                    }))
                  }
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                  placeholder={"Sélectionnez le type de risque"}
                  isSearchable={true}
                  noOptionsMessage={() => t("NorecordsfoundLabel")}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Base QR</Form.Label>
                <MultiSelect
                  options={QRBasisOptions}
                  value={formData.qr_basis_ids}
                  onChange={handleQRBasisChange}
                  labelledBy="Select QR Basis"
                  overrideStrings={{
                    selectSomeItems: "Sélectionnez la base QR",
                    allItemsAreSelected:
                      "Toutes les options sont sélectionnées",
                    selectAll: "Tout sélectionner",
                    search: "Recherche",
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Base de devis</Form.Label>
                <MultiSelect
                  options={QuotationBasisOptions}
                  value={formData.quotation_basis_ids}
                  onChange={handleQuotationBasisChange}
                  labelledBy="Select Quotation Basis"
                  overrideStrings={{
                    selectSomeItems: "Sélectionner la base du devis",
                    allItemsAreSelected:
                      "Toutes les options sont sélectionnées",
                    selectAll: "Tout sélectionner",
                    search: "Recherche",
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Base de garantie <span>*</span>
                </Form.Label>
                <MultiSelect
                  options={GuaranteeBasisOptions}
                  value={formData.guarantee_basis_ids}
                  onChange={handleGuaranteeBasisChange}
                  labelledBy="Select Guarantee Basis"
                  overrideStrings={{
                    selectSomeItems: "Sélectionnez la base de garantie",
                    allItemsAreSelected:
                      "Toutes les options sont sélectionnées",
                    selectAll: "Tout sélectionner",
                    search: "Recherche",
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Tapez ici..."
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancel-btn"
              variant="primary"
              onClick={handleModalClose}
            >
              {t("cancelLabel")}
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              Ajouter
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddProduct;
